/**
 * TrophyIcon — sanitized from `assets/newSvg/trophy.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function TrophyIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M16.6171,3 C17.6258,3 18.4766,3.75107 18.6017,4.75193 L18.7577,6 L19.4263,6 C20.8714,6 21.9553,7.32212 21.6719,8.7392 L21.4708,9.74466 C21.1596,11.3007 19.9811,12.4983 18.4992,12.8752 C17.4922,15.0102 15.4578,16.5902 12.9999,16.9313 L12.9999,19 L15.9999,19 C16.5522,19 16.9999,19.4477 16.9999,20 C16.9999,20.5523 16.5522,21 15.9999,21 L7.99993,21 C7.44764,21 6.99993,20.5523 6.99993,20 C6.99993,19.4477 7.44764,19 7.99993,19 L10.9999,19 L10.9999,16.9313 C8.54203,16.5902 6.50763,15.0102 5.50062,12.8752 C4.01874,12.4983 2.84026,11.3007 2.52906,9.74466 L2.32796,8.7392 C2.04455,7.32212 3.12843,6 4.57357,6 L5.24215,6 L5.39815,4.75193 C5.52326,3.75107 6.37406,3 7.38271,3 L16.6171,3 Z M19.4263,8 L19.0077,8 L19.124,8.93002 C19.1748,9.3364 19.1907,9.73828 19.1742,10.1329 C19.30324,9.950316 19.403608,9.7448584 19.4680848,9.52238448 L19.5096,9.35243 L19.7107,8.34697 C19.7421125,8.1899075 19.6409187,8.04205547 19.4925338,8.00754656 L19.4263,8 Z M4.99215,8 L4.57357,8 C4.39052,8 4.25323,8.16747 4.28913,8.34697 L4.49022,9.35243 C4.54787,9.6407 4.66434,9.90467 4.82563,10.1329 C4.80917,9.73828 4.8251,9.3364 4.87589,8.93002 L4.99215,8 Z"
        fill={color}
      />
    </Svg>
  );
}

export default TrophyIcon;
